var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 170,
    viewBox: "0 0 162 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.885 48.0386L88.4652 0L103.365 53.2203L133.807 59.4108L133.807 73.3812L128.763 81.3056L161.376 98.9188V110.828L89.1114 166L27.3757 131.244V117.39L34.9568 114.654L21 111.345L21 98.3983L61.9944 45.7493L77.6952 48L77.885 48.0386Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9583 119.39L78.694 154.389L150.958 100.919M16.9583 119.39V133.244L78.694 168L150.958 112.828V100.919M16.9583 119.39L21.6294 115.811M150.958 100.919L117.78 83",
    stroke: "#696969",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5826 100.398L87.6044 118.138L123.389 61.4108M10.5826 100.398L51.577 47.7493L67.2778 50.7362M10.5826 100.398L10.5826 113.345L87.6044 131.606L123.389 75.3812L123.389 61.4108M123.389 61.4108L93.2278 55.6729",
    stroke: "#696969",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0478 2L63.9583 65.9727C63.9583 71.7587 74.7045 76.0977 80.1971 75.9983C85.4508 75.9033 95.9583 71.2902 95.9583 65.9727L78.0478 2Z",
    stroke: "#696969",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9967 51.9H80.9464L80.9164 51.9404L79.5006 53.8458L78.1053 51.9409L78.0754 51.9H78.0247H73.8339H73.7393L73.734 51.9944L72.9002 66.9944L72.8943 67.1H73H77.6612H77.7592L77.7612 67.002L77.8427 62.8559L79.4372 64.1421L79.5 64.1928L79.5628 64.1421L81.1573 62.8559L81.2388 67.002L81.2408 67.1H81.3388H86H86.1057L86.0998 66.9944L85.266 51.9944L85.2607 51.9H85.1661H80.9967ZM81.859 53.6523L79.5 56.6387L77.141 53.6523L77.1109 53.6143H77.0625H75.523H75.4278L75.4231 53.7094L74.8077 66.2571H73.8967L74.6342 52.7429H77.59L79.4202 55.1674L79.5 55.2731L79.5798 55.1674L81.41 52.7429H84.3658L85.1033 66.2571H84.1923L83.5769 53.7094L83.5722 53.6143H83.477H81.9375H81.8891L81.859 53.6523ZM81.8755 61.1787L79.5 63.0582L77.1245 61.1787L76.9676 61.0545L76.9625 61.2546L76.8367 66.2571H75.735L76.3238 54.4571H76.6293L79.4217 57.9764L79.5003 58.0755L79.5786 57.9762L82.3495 54.4571H82.6761L83.2438 66.2571H82.1633L82.0375 61.2546L82.0324 61.0545L81.8755 61.1787Z",
    fill: "#696969",
    stroke: "#696969",
    strokeWidth: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M117.59 14.7008L109.41 36.7992",
    stroke: "#696969",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M133 13L113 46",
    stroke: "#696969",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M147.628 16.2412L130.872 37.2587",
    stroke: "#696969",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkTimeIcon);
export default __webpack_public_path__ + "static/media/work-time-icon.a23f36525184f0201a8fa146c2941653.svg";
export { ForwardRef as ReactComponent };